import { authLogin, authLogout, authUpdate, authroleGet } from './authAction';
import { menusGet } from '../../common/reduxs/menu/menusAction';
import {
  asyncActionFinish,
  asyncActionError,
} from '../../common/reduxs/async/asyncActions';
import { ASYNC_ACTION_START } from '../../common/reduxs/async/asyncConstant';
import { toastr } from 'react-redux-toastr';
import { closeModal } from '../../modals/redux/modalActions';
import {
  SITE_ADDRESS,
  SITE_ADDRESS_PEMBELAJARAN,
} from '../../common/data/siteConfig';
import { authUpdating } from '../../common/utilities/checkAuth';
import {
  profilGet,
  profilUpdate,
} from '../../../menus/profile/redux/reduxAction';
import { checkRes, checkErr } from '../../common/helpers/checkRes';
import { Menus } from '../../common/data/menus';
import { fetchWithTimeOut } from '../../common/helpers/othersHelpers';
const jwtDecode = require('jwt-decode');

export const loginAuth = (creds) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'loginAuth' });
    try {
      const formData = new FormData();
      const username = creds.username.trim();
      const password = creds.password.trim();
      formData.append('username', username);
      formData.append('password', password);
      let authUrl = 'auth/login';

      let fetchData = await fetchWithTimeOut(
        SITE_ADDRESS + authUrl,
        {
          method: 'POST',
          body: formData,
        },
        90
      );
      const response = await fetchData.json();
      if (fetchData.status !== 200) {
        const error = new Error(response.message);
        throw error;
      }
      const user = response.user;
      const profile = response?.profile && JSON.parse(response?.profile);

      const sessionId = response.sessionId;
      const deviceId = response.deviceId;
      const FullMenus = [...Menus];
      const urlPhoto = response.urlPhoto;
      const authUpdated = authUpdating(user.role, FullMenus, user.userId);
      const expiresIn = jwtDecode(user.token);

      let setUser = {
        isAuth: true,
        token: user.token,
        sessionId: sessionId,
        deviceId: deviceId,
        vusn: creds.username,
        userId: user.userId,
        noabsen: user.noabsen,
        username: user.vusn,
        nis: user.nis,
        name: user.name,
        role: user?.role,
        active_year: user.active_year,
        active_sem: user.active_sem,
        active_kelas: user.active_kelas,
        active_tingkat: user.active_tingkat,
        active_jenjang: user.active_jenjang && parseInt(user.active_jenjang),
        authorities: authUpdated,
        mainPhoto: urlPhoto,
        expiresIn: expiresIn.exp * 1000,
        emailRecovery: user.emailRecovery,
      };
      if (setUser.role !== 'Siswa') {
        setUser = {
          ...setUser,
          userId: user.userId_role,
          userId_siswa: user.userId,
          vusn_role: user.vusn_role,
          username_role: user.username_role,
        };
      }
      dispatch(menusGet(Menus));
      dispatch(authLogin(setUser));
      dispatch(profilGet({ profile: { ...profile, urlPhoto } }));
      dispatch(asyncActionFinish());
      return 'finish';
    } catch (err) {
      console.log(err);
      toastr.warning('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};

export const newAuthDashboard = (creds, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'newAuthDashboard' });
    try {
      const formData = new FormData();
      formData.append('vusn', creds.vusn);
      formData.append('userId', creds.userId);
      formData.append('deviceId', creds.deviceId);
      let fetchData = await fetch(SITE_ADDRESS + 'auth/new-authdashboard', {
        method: 'POST',
        body: formData,
      });
      const response = await fetchData.json();
      if (fetchData.status !== 200) {
        const error = new Error(response.message);
        throw error;
      }
      const user = response.user;
      const sessionId = response.sessionId;
      const deviceId = response.deviceId;
      const urlPhoto = response.urlPhoto;
      const authUpdated = authUpdating(user.role, user.userId);
      const expiresIn = jwtDecode(user.token);
      let setUser = {
        isAuth: true,
        token: user.token,
        sessionId: sessionId,
        deviceId: deviceId,
        vusn: user.vusn,
        userId: user.userId,
        username: user.vusn,
        nis: user.nis,
        name: user.name,
        role: user?.role,
        active_year: user.active_year,
        active_sem: user.active_sem,
        active_kelas: user.active_kelas,
        active_tingkat: user.active_tingkat,
        active_jenjang: user.active_jenjang && parseInt(user.active_jenjang),
        authorities: authUpdated,
        mainPhoto: urlPhoto,
        expiresIn: expiresIn.exp * 1000,
        emailRecovery: user.emailRecovery,
      };
      if (setUser.role !== 'Siswa') {
        setUser = {
          ...setUser,
          userId: user.userId_role,
          userId_siswa: user.userId,
          vusn_role: user.vusn_role,
          username_role: user.username_role,
        };
      }
      dispatch(menusGet(Menus));
      dispatch(authLogin(setUser));
      dispatch(profilUpdate({ urlPhoto: urlPhoto }));
      dispatch(asyncActionFinish());
      return 'finish';
    } catch (error) {
      console.log(error);
      toastr.error('Error', error.message);
      dispatch(asyncActionError());
    }
  };
};

export const forgetPasswordAuth = (history, data) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'forgetPasswordAuth' });
    try {
      const formData = new FormData();
      const email = data.email.trim();
      formData.append('email', email);
      formData.append('url', data.url);

      let fetchData = await fetchWithTimeOut(
        SITE_ADDRESS_PEMBELAJARAN + 'email/forget-password',
        {
          method: 'POST',
          body: formData,
        },
        90
      );
      const response = await fetchData.json();
      if (fetchData.status !== 200) {
        const error = new Error(response.message);
        throw error;
      }
      const status = response.status;
      dispatch(asyncActionFinish());
      return status;
    } catch (err) {
      console.log(err);
      toastr.warning('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};

export const resetPasswordAuth = (history, data) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'resetPasswordAuth' });
    try {
      const formData = new FormData();
      const username = data.username.trim();
      const password = data.password.trim();
      const token = data.token;
      formData.append('username', username);
      formData.append('password', password);
      formData.append('token', token);

      let fetchData = await fetchWithTimeOut(
        SITE_ADDRESS_PEMBELAJARAN + 'email/reset-password',
        {
          method: 'POST',
          body: formData,
        },
        90
      );
      const response = await fetchData.json();
      if (fetchData.status !== 201) {
        const error = new Error(response.message);
        throw error;
      }
      const status = response.status;
      dispatch(asyncActionFinish());
      return status;
    } catch (err) {
      console.log(err);
      toastr.warning('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};
// Change Sibling Student Profile
export const updateAuth = (values, auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'updateAuth' });
    try {
      const vusn = auth.vusn;
      const userIdnew = values.userIdnew;
      const sessionId = auth.sessionId ? auth.sessionId : '';
      const deviceId = auth.deviceId ? auth.deviceId : '';
      const formData = new FormData();
      formData.append('vusn', vusn);
      formData.append('userId', auth.userId);
      formData.append('userIdnew', userIdnew);
      formData.append('usernameNew', values.username);
      formData.append('sessionId', sessionId);
      formData.append('deviceId', deviceId);
      let fetchData = await fetch(SITE_ADDRESS + 'auth/sibling-student', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }
      const username = values.username;
      const token = response.token;
      const urlPhoto = response.urlPhoto;
      const expiresIn = jwtDecode(token);
      const setUser = {
        userId: userIdnew,
        username: username,
        token: token,
        mainPhoto: urlPhoto,
        expiresIn: expiresIn.exp * 1000,
      };
      dispatch(authUpdate(setUser));
      dispatch(profilUpdate({ urlPhoto: urlPhoto }));
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
    }
  };
};
// register parents accounts step 1 Login with student username & password
export const registerAuth = (history, creds) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'registerAuth' });
    try {
      const formData = new FormData();
      const username = creds.username.trim();
      const password = creds.password.trim();
      formData.append('username', username);
      formData.append('password', password);
      let authUrl = 'auth/login';
      let fetchData = await fetchWithTimeOut(
        SITE_ADDRESS + authUrl,
        {
          method: 'POST',
          body: formData,
        },
        90
      );
      const response = await fetchData.json();
      if (fetchData.status !== 200) {
        const error = new Error(response.message);
        throw error;
      }
      const user = response.user;
      const sessionId = response.sessionId;
      const deviceId = response.deviceId;
      const FullMenus = [...Menus];
      const urlPhoto = response.urlPhoto;
      const authUpdated = authUpdating(user.role, FullMenus, user.userId);
      const expiresIn = jwtDecode(user.token);
      let setUser = {
        isAuth: true,
        token: user.token,
        sessionId: sessionId,
        deviceId: deviceId,
        vusn: creds.username,
        userId: user.userId,
        username: user.siswa,
        nis: user.nis,
        name: user.name,
        role: user.role,
        active_year: user.active_year,
        active_sem: user.active_sem,
        active_kelas: user.active_kelas,
        active_tingkat: user.active_tingkat,
        active_jenjang: user.active_jenjang,
        authorities: authUpdated,
        mainPhoto: urlPhoto,
        expiresIn: expiresIn.exp * 1000,
        registerParents: true,
      };
      dispatch(menusGet(Menus));
      dispatch(authLogin(setUser));
      dispatch(profilUpdate({ urlPhoto: urlPhoto }));
      dispatch(asyncActionFinish());
      history.push('/register-2');
      return 'finish';
    } catch (err) {
      console.log(err);
      toastr.warning('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};

export const getRoleAuth = (auth, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'getRoleAuth' });
    try {
      const vusn = auth.vusn;
      const userId = auth.userId;
      const sessionId = auth.sessionId ? auth.sessionId : '';
      const deviceId = auth.deviceId ? auth.deviceId : '';
      const formData = new FormData();
      formData.append('vusn', vusn);
      formData.append('userId', userId);
      formData.append('sessionId', sessionId);
      formData.append('deviceId', deviceId);

      let fetchData = await fetch(SITE_ADDRESS + 'auth/role-get', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);
      if (resultCheck) {
        throw resultCheck;
      }

      let defaultRole = ['Ayah', 'Ibu', 'Wali'];

      let role = response?.role && JSON.parse(response.role);

      let filterRole = defaultRole.filter((item) => {
        return !role.includes(item);
      });

      dispatch(authroleGet({ detail: filterRole }));
      dispatch(asyncActionFinish());
    } catch (error) {
      checkErr(error);
      dispatch(asyncActionError());
    }
  };
};

export const registerUserRole = (auth, history, values) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: 'registerUserRole' });
    const vusn = auth.vusn;
    const userId = auth.userId;
    const sessionId = auth.sessionId ? auth.sessionId : '';
    const deviceId = auth.deviceId ? auth.deviceId : '';
    const usernamereg = values.usernamereg;
    const passwordreg = values.passwordreg;
    const rolereg = values.rolereg;
    const formData = new FormData();
    formData.append('vusn', vusn);
    formData.append('userId', userId);
    formData.append('sessionId', sessionId);
    formData.append('deviceId', deviceId);
    formData.append('usernamereg', usernamereg);
    formData.append('passwordreg', passwordreg);
    formData.append('rolereg', rolereg);
    try {
      let fetchData = await fetch(SITE_ADDRESS + 'auth/role-register', {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      });
      const response = await fetchData.json();
      const resultCheck = checkRes(response, fetchData, dispatch, 200, history);

      if (response.status === 'duplicate') {
        toastr.warning('Warning', response.message);
        dispatch(asyncActionFinish());
        return;
      }
      if (resultCheck) {
        throw resultCheck;
      }
      history.push('/register-3');
      dispatch(closeModal());
      dispatch(asyncActionFinish());
    } catch (err) {
      toastr.error('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};

export const sessionLogout = (elementName, history) => {
  return async (dispatch) => {
    dispatch({ type: ASYNC_ACTION_START, payload: elementName });
    try {
      history.push('/');
      dispatch(authLogout());
      dispatch(closeModal());
      dispatch(asyncActionFinish());
    } catch (err) {
      console.log(err);
      toastr.error('Error', err.message);
      dispatch(asyncActionError());
    }
  };
};
